import CreateCustomer from "../../../components/billing/customer/CreateCustomer";
import PayAndSubscribe from "../../../components/billing/payment/PaymentMethod";
import ShowPlans from "../../../components/billing/plans/ShowPlans";
import useBillingContext, { eBillingStep } from "../../../context/BillingContext";

export function StepManager() {
    const { step } = useBillingContext()

    function getStepModal() {
        if (step === eBillingStep.PLAN) {
            return <ShowPlans />
        } else if (step === eBillingStep.CREATE_CUSTOMER) {
            return <CreateCustomer />
        } else if (step === eBillingStep.PAYMENT) {
            return <PayAndSubscribe />
        }

        return <></>
    }


    return getStepModal()
}